import type { HttpErrorResponse } from '@angular/common/http';

import {
  createEntityCollectionStore,
  DEFAULT_SCOPE_NAME,
  ngrxEvent,
  pipeState,
} from '@core/ngrx-legacy';
import type { ActionScopedPayload } from '@core/ngrx-legacy';
import type { Position } from '@core/positions-and-skills-types';

import { EntityStoreKey } from './types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Position>()(
  EntityStoreKey.Positions,
  {
    customActions: adapter => ({
      fetchCollectionSuccess: (state, { data, scope }: ActionScopedPayload<Position[]>) =>
        pipeState(
          state,
          next => adapter.upsertMany(next, data, { scope }),
          next =>
            adapter.markAsLoaded(next, {
              scope: scope || DEFAULT_SCOPE_NAME,
              entities: data.map(position => position.id),
            }),
        ),
      fetchSuggestion: ngrxEvent<{ offerId?: number; offerTemplateId?: number }>(),
      fetchSuggestionSuccess: ngrxEvent<{ data: Position | null }>(),
      fetchSuggestionFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
    }),
  },
);

export {
  selectors as PositionsSelectors,
  actions as PositionsActions,
  reducer as PositionsReducer,
  namespace as PositionsNamespace,
};
